import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import { componentID } from "core/services/componentService/component-service-base";
import React from "react";
import { NodeProps } from "reactflow";
import { useAppSelector } from "src/stores/redux/hooks";
import { getAppStatus, getSelectedNode } from "../helpers/selectors";
import { ErrorStatus, NodeCategory, NodeContent, NodeHandle, NodeStats, showStats } from "./node.commons";
import { getNodeContainerStyles } from "./node.styles";
import StreamNodeAdd from "../add-new-node/add-new-node";
import WithTooltip from "src/generic/tooltip/tooltip";

interface NodeData {
    label: string;
    type?: string;
    componentType?: string;
    componentId: componentID;
    metaObject?: any;
    metaObjectId?: string;
    stats?: any;
    isDimmed?: boolean;
}

const Node = ({ data, sourcePosition, targetPosition, id }: NodeProps<NodeData>) => {
    const appStatus = useAppSelector(getAppStatus);
    const selectedNode = useAppSelector(getSelectedNode);
    const selected = selectedNode?.id === id;
    const isInvalid = data.metaObject?.metaInfoStatus?.isValid === false;

    const isLabelOverflowing = label => {
        const labelId = `node-name-${label}`;
        const el = document.getElementById(labelId);
        return el ? el.scrollWidth > el.clientWidth : false;
    };

    return (
        <>
            {WithTooltip(
                <Box
                    sx={[
                        getNodeContainerStyles(selected || false, isInvalid, sourcePosition),
                        !!data.isDimmed && { opacity: 0.5, filter: "grayscale(1)" }
                    ] as SxProps<Theme>}
                    data-test-id={`node_container_${data?.metaObjectId === "temp-node" ? "New " : ""}${data.label}`}
                >
                    <NodeCategory type={data.type} selected={selected} />
                    {selected && <StreamNodeAdd nodeId={id} data={data} />}
                    {showStats(appStatus) && <NodeStats stats={data.stats} />}
                    <NodeContent data={data} />
                    {isInvalid && <ErrorStatus />}
                    <NodeHandle sourcePosition={sourcePosition} targetPosition={targetPosition} nodeId={id} />
                </Box>,
                isLabelOverflowing(data.label) ? data.label : null
            )}
        </>
    );
};

export default Node;
